(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = (root = document) => {
    root.querySelectorAll('[data-nl-atelier]').forEach(section => {
      if (section.dataset.nlInitialized) return;
      section.dataset.nlInitialized = 'true';
      if (section.dataset.motion !== 'true' || reducedMotion.matches || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('nl-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      section.querySelectorAll('[data-nl-reveal]').forEach(element => {
        if (element.getBoundingClientRect().top <= window.innerHeight) return;
        element.classList.add('nl-reveal-ready');
        observer.observe(element);
      });
      const revealAll = () => {
        if (!reducedMotion.matches) return;
        observer.disconnect();
        section.querySelectorAll('.nl-reveal-ready').forEach(element => element.classList.add('nl-revealed'));
      };
      reducedMotion.addEventListener('change', revealAll);
      section.addEventListener('focusin', event => {
        const target = event.target.closest('[data-nl-reveal]');
        if (target) target.classList.add('nl-revealed');
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target.parentElement));
})();

(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const reveal = element => element.classList.remove('nl-scroll-waiting');
  const initialize = () => {
    const main = document.querySelector('#MainContent[data-template^="product"]');
    if (!main || motion.matches || !('IntersectionObserver' in window)) return;
    if (!observer) observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 24px 0px' });
    const candidates = main.querySelectorAll('.product-information__media li.product-media-container, .product-details .rte, product-recommendations .product-card, .product-recommendations .product-card');
    candidates.forEach(element => {
      if (element.dataset.nlScroll || element.closest('dialog') || element.getBoundingClientRect().height === 0) return;
      element.dataset.nlScroll = 'true';
      if (element.getBoundingClientRect().top <= innerHeight) return;
      element.classList.add('nl-scroll-reveal', 'nl-scroll-waiting');
      observer.observe(element);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:select', initialize);
  document.addEventListener('recommendations:loaded', initialize);
  document.addEventListener('focusin', event => {
    const element = event.target.closest('.nl-scroll-waiting');
    if (element) reveal(element);
  });
  motion.addEventListener('change', () => {
    if (motion.matches) {
      observer?.disconnect();
      document.querySelectorAll('.nl-scroll-waiting').forEach(reveal);
    } else initialize();
  });
})();
